const TOTAL_COUNT_LIMIT = 10000;

export const getTotalCount = (totalCount: number): number =>
  totalCount > TOTAL_COUNT_LIMIT ? TOTAL_COUNT_LIMIT : totalCount;
